/* istanbul ignore next */
import React, { useContext } from 'react';
import {
  convertTime,
  filterNotHiddenProducts,
  getTernaryValue,
  isCateringDisposition,
  isSupportedTenantCode,
} from 'common/utilities/utils';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { MENU_PLP_CONSTANT, TIMER_I18Next } from '../MenuPLPConstants/MenuPLPConstants';
import { UserOrderContext } from 'context/context';
import View_1UP_Icon from 'styles/staticAssets/images/View_1UP_Icon.svg';
import View_1UP_Icon_Inactive from 'styles/staticAssets/images/View_1UP_Icon_Inactive.svg';
import View_carousal_Icon from 'styles/staticAssets/images/View_carousal_Icon.svg';
import View_carousal_Icon_Inactive from 'styles/staticAssets/images/View_carousal_Icon_Inactive.svg';
import { renderItemList, searchModeElmnt } from '../MenusPlpUtilities/MenuPLPSharedUtils';
import { ReactSVG } from 'react-svg';
import Product_Card_Icon from 'styles/staticAssets/images/Product_Card_Icon.svg';
import ribbonRedOutlined from 'styles/staticAssets/images/ribbonRedOutlined.svg';
import TimerIcon from 'styles/staticAssets/images/TimerIcon.svg';
import { Col } from 'reactstrap';
import MenuItemList from './MenuItemList';
import { changeMenulistOrder } from '../MenusPlpUtilities/MenusPlpUtils';
import DynamicHeadings from 'atoms/DynamicHeadings/DynamicHeadings';
import { convertTimeString } from 'organisms/SearchStore/AU/SearchStoreUtilities/SearchStoreUtils';
import { getStoreDetails } from 'organisms/HeaderComponent/AU/HeaderUtilities/HeaderUtils';
import { useSelector } from 'react-redux';
import { getValueOrDefaultObject } from '../../../../common/utilities/utils';
import { getCheckTimeSpecificCategoryAvailability } from 'molecules/DynamicMenuAlert/AU/Utils/DynamicMenuAlertUtils';

const {
  CARD_TYPE: { SMALL, CAROUSAL },
} = MENU_PLP_CONSTANT;
const renderItemListItems = (
  productsList,
  cardId,
  cType,
  subCategories,
  tenantData,
  catalogs,
  storeClosedData,
  selectedCat,
  getCardCount,
  viewUp,
) => {
  if (cType === 'viewup') {
    cType = viewUp ? SMALL : CAROUSAL;
  }
  return renderItemList(
    productsList,
    cardId,
    cType,
    tenantData,
    catalogs,
    storeClosedData,
    selectedCat,
    getCardCount,
    subCategories,
  );
};
const getClassForMenu = index => {
  if (isSupportedTenantCode()) {
    return 'medium-category-name';
  } else {
    return index === 0 ? 'large-category-name' : 'medium-category-name';
  }
};

const dynamicMenuTime = (isTimeSpecific, className, availability) => {
  const availabilityHrs = availability?.length ? availability?.[0] : null;
  return isTimeSpecific && availabilityHrs ? (
    <div className={className}>
      From {convertTimeString(convertTime(availabilityHrs?.availableHours?.startTime?.time))} till{' '}
      {convertTimeString(convertTime(availabilityHrs?.availableHours?.endTime?.time))}
    </div>
  ) : null;
};
const getClassForSearchMenuItem = dispositionType => {
  if (isSupportedTenantCode()) {
    return getTernaryValue(
      isCateringDisposition(dispositionType),
      'sopac-medium-menu-container sopac-medium-catering-container',
      'sopac-medium-menu-container',
    );
  } else {
    return 'medium-menu-container';
  }
};
const desktopMenuItems = (
  dname,
  index,
  specials,
  discount,
  exclusive,
  timer,
  id,
  products,
  subCategories,
  tenantData,
  catalogs,
  storeClosedData,
  selectedCat,
  getCardCount,
  viewUp,
  isTimeSpecific,
  availability,
  timeBasedCetegory,
) => {
  return (
    <div>
      {
        <>
          <div className={getClassForMenu(index)}>
            {/*Line number 85 updated.Reference Jira RENDEV-16664*/}
            <h1>{dname[0]?.value} </h1>
          </div>
          {dynamicMenuTime(isTimeSpecific, 'dynamic-menu-time-desk', availability)}
        </>
      }
      <ReactSVG
        src={specials ? Product_Card_Icon : discount || (exclusive && ribbonRedOutlined) || ''}
        className={
          specials ? 'specials-product-ribbon' : (exclusive && 'exclusive-product-ribbon') || 'discount-product-ribbon'
        }
      />
      <span className={specials ? 'specials-ribbon-text' : 'discount-ribbon-text'}>
        {timer ? (
          <div>
            <ReactSVG src={TimerIcon} className='product-timer' />
            <span className='product-timer-text'>{translateWithI18Next(TIMER_I18Next)}</span>
          </div>
        ) : specials || ( discount || ( exclusive || null ))}
      </span>
      {index === 0
        ? renderItemListItems(
            products,
            id,
            'large',
            subCategories,
            tenantData,
            catalogs,
            storeClosedData,
            selectedCat,
            getCardCount,
            viewUp,
          )
        : renderItemListItems(
            products,
            id,
            'medium',
            subCategories,
            tenantData,
            catalogs,
            storeClosedData,
            selectedCat,
            getCardCount,
            viewUp,
          )}
    </div>
  );
};

const getClassName = (localized, isSmartBannerVisible, index) => {
  if (localized && document?.getElementById('select-start-order-items')?.clientHeight > 40) {
    if (index === 0) {
      return 'offsetFirstIndex';
    }
    if (!isSmartBannerVisible && index === 0) {
      return 'offsetFirstIndexWithBanner';
    } else {
      return 'offsetOtherIndex';
    }
  } else if (localized) {
    return 'offsetWithLocalized';
  } else if (!isSmartBannerVisible && index === 0) {
    return 'offsetFirstIndexWithBanner';
  }
};
const mobileMenuItems = (
  products,
  index,
  dname,
  id,
  subCategories,
  viewUp,
  changeViewtoUp,
  viewCarousal,
  changeViewtoCarousal,
  carouselCount,
  tenantData,
  storeClosedData,
  catalogs,
  selectedCat,
  getCardCount,
  localized,
  isSmartBannerVisible,
  isTimeSpecific,
  availability,
) => {
  return (
    <>
      {isSupportedTenantCode() ? (
        // for AUSTRALIA
        <div className={getClassName(localized, isSmartBannerVisible, index)}>
          <div className='d-flex position-relative'>
            {/*Line number 180 updated.Reference Jira RENDEV-16664*/}
            <DynamicHeadings className='small-category-name' value={dname[0]?.value} />
          </div>
          {dynamicMenuTime(isTimeSpecific, 'dynamic-menu-time-mob', availability)}
          {renderItemListItems(
            products,
            id,
            'viewup',
            subCategories,
            tenantData,
            catalogs,
            storeClosedData,
            selectedCat,
            getCardCount,
            viewUp,
          )}
        </div>
      ) : (
        // for India
        <div>
          {filterNotHiddenProducts(products) > 1 && index === 1 && (
            <div>
              <div className='product-view-section'>
                <span className='product-view'>{translateWithI18Next(MENU_PLP_CONSTANT.PRODUCT_VIEW_TEXT)}:</span>
                <ReactSVG
                  src={(viewUp && View_1UP_Icon ) || View_1UP_Icon_Inactive}
                  className='product-view-up-icon'
                  onClick={changeViewtoUp}
                  data-testid='change-view-to-up'
                />
                <ReactSVG
                  src={(viewCarousal && View_carousal_Icon) || View_carousal_Icon_Inactive}
                  className='product-view-carousal-icon'
                  onClick={changeViewtoCarousal}
                  data-testid='change-view-to-carousal'
                />
              </div>
              <hr className='product-view-divider'></hr>
            </div>
          )}
          <div className='d-flex position-relative'>
            <div className='small-category-name'>{dname[0].value}</div>
            {!viewUp && (
              <div className='card-counter'>
                {carouselCount}/{filterNotHiddenProducts(products)}
              </div>
            )}
          </div>
          {(index === 0
            && renderItemListItems(
                products,
                id,
                'carousal',
                subCategories,
                tenantData,
                catalogs,
                storeClosedData,
                selectedCat,
                getCardCount,
                viewUp,
              )
            ) || renderItemListItems(
                products,
                id,
                'viewup',
                subCategories,
                tenantData,
                catalogs,
                storeClosedData,
                selectedCat,
                getCardCount,
                viewUp,
              )}
        </div>
      )}
    </>
  );
};
const OnSerchElmnt = (
  searchMode,
  filterList,
  dietaryList,
  products,
  isMobile,
  viewUp,
  tenantData,
  getCardCount,
  catalogs,
  storeClosedData,
  clearSearch,
  recommendProducts,
  carouselCount,
  dispositionType,
) => {
  if ((searchMode.isSearchedMode || [...filterList, ...dietaryList].length) && products?.length) {
    return (
      <div className={isMobile ? 'sopac-small-menu-container' : getClassForSearchMenuItem(dispositionType)}>
        <MenuItemList
          productList={products}
          cardType={isMobile ? (viewUp && 'small') || 'carousal' : 'medium'}
          tenantData={tenantData}
          cardCount={isMobile && getCardCount}
          categoryId={''}
          catalogs={catalogs}
          storeClosedData={storeClosedData}
        />
      </div>
    );
  } else {
    return (
      searchMode.isSearchedMode &&
      searchModeElmnt(
        searchMode,
        clearSearch,
        recommendProducts,
        tenantData,
        catalogs,
        storeClosedData,
        isMobile,
        'carousal',
        'CAT86',
        carouselCount,
        getCardCount,
      )
    );
  }
};
const getClass = (isMobile, index, viewCarousal, dispositionType) => {
  // eslint-disable-next-line no-unused-expressions
  if (isSupportedTenantCode()) {
    return isMobile
      ? 'sopac-small-menu-container'
      : getTernaryValue(
          isCateringDisposition(dispositionType),
          'sopac-medium-menu-container sopac-medium-catering-container',
          'sopac-medium-menu-container',
        );
  } else {
    return isMobile
      ? index === 0 || (( viewCarousal
        && 'carousal-menu-container'
       ) || 'small-menu-container' )
      : (( index === 0
      && 'large-menu-container'
      ) || 'medium-menu-container' );
  }
};

const MenuItems = ({
  isMobile,
  searchMode,
  categories,
  viewCarousal,
  viewUp,
  changeViewtoUp,
  changeViewtoCarousal,
  carouselCount,
  tenantData,
  catalogs,
  storeClosedData,
  selectedCat,
  getCardCount,
  filterList,
  dietaryList,
  products,
  clearSearch,
  recommendProducts,
  localized,
  dispositionType,
}) => {
  const updatedCategories = categories?.length && changeMenulistOrder(categories);
  const { userOrderState } = useContext(UserOrderContext);
  const { timeBasedCetegory } = userOrderState;
  const { menuReducer } = useSelector(data => data);
  const storeData = useSelector(data => getValueOrDefaultObject(data.storesReducer));
  const getUpdateStoreDetails = () => {
    return storeData?.storesWithStatus && getStoreDetails(storeData?.storesWithStatus[0]);
  };
  const getStoreDetail = getUpdateStoreDetails();

  const checkItemExpiry = name => {
    if (timeBasedCetegory?.timeDifference) {
      return false;
    }
    const item = { categoryName: name };
    return getCheckTimeSpecificCategoryAvailability({ item, getStoreDetail, menuReducer, showModal: false });
  };

  return (
    <Col className={isMobile ? 'mob-plp-col' : ''}>
      {!searchMode?.isSearchedMode && updatedCategories?.length
        ? updatedCategories
            .filter(({ isHidden }) => !isHidden)
            .map(
              (
                {
                  id,
                  name,
                  dname,
                  imageName,
                  products,
                  categories,
                  isHidden,
                  displayOrder,
                  specials,
                  exclusive,
                  timer,
                  discount,
                  isTimeSpecific,
                  availability,
                },
                index,
              ) => {
                return (
                  !isHidden &&
                  !checkItemExpiry(name) && (
                    <div
                      id={name?.trim()}
                      className={getClass(isMobile, index, viewCarousal, dispositionType)}
                      key={index}
                    >
                      {isMobile
                        ? mobileMenuItems(
                            products,
                            index,
                            dname,
                            id,
                            categories,
                            viewUp,
                            changeViewtoUp,
                            viewCarousal,
                            changeViewtoCarousal,
                            carouselCount,
                            tenantData,
                            storeClosedData,
                            catalogs,
                            selectedCat,
                            getCardCount,
                            localized,
                            isMobile,
                            isTimeSpecific,
                            availability,
                          )
                        : desktopMenuItems(
                            dname,
                            index,
                            specials,
                            discount,
                            exclusive,
                            timer,
                            id,
                            products,
                            categories,
                            tenantData,
                            catalogs,
                            storeClosedData,
                            selectedCat,
                            getCardCount,
                            viewUp,
                            isTimeSpecific,
                            availability,
                            timeBasedCetegory,
                          )}
                    </div>
                  )
                );
              },
            )
        : OnSerchElmnt(
            searchMode,
            filterList,
            dietaryList,
            products,
            isMobile,
            viewUp,
            tenantData,
            getCardCount,
            catalogs,
            storeClosedData,
            clearSearch,
            recommendProducts,
            carouselCount,
            dispositionType,
          )}
    </Col>
  );
};

export default React.memo(MenuItems);
